'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COOKIE_NAME = exports.isMobileDevice = exports.isWebview = exports.isIOSDevice = exports.expireIsWebviewCookie = undefined;

var _querystring = require('querystring');

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var COOKIE_NAME = 'isWebview';

var expireIsWebviewCookie = function expireIsWebviewCookie() {
  document.cookie = COOKIE_NAME + '=0;path=/; expires=' + new Date();
};

var isMobile = function isMobile() {
  return __CLIENT__ && !window.matchMedia('(min-width: 48em)').matches || __TEST__ && window.forceMobileForTesting;
};

var isMobileDevice = function isMobileDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (__CLIENT__ || __TEST__) && navigator.userAgent;
  return (__CLIENT__ || __TEST__) && /iPad|iPhone|iPod|Android|BlackBerry/.test(userAgent) && !window.MSStream;
};
var isIOSDevice = function isIOSDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (__CLIENT__ || __TEST__) && navigator.userAgent;
  return (__CLIENT__ || __TEST__) && /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

var isWebview = function isWebview(queryString) {
  var webview = false;
  if (__CLIENT__ || __TEST__) {
    var hasWebviewCookie = _cookie2.default.parse(document.cookie)[COOKIE_NAME] === '1';
    var queryParams = (0, _querystring.parse)((queryString || '').replace(/^\?/, ''));
    var hasWebviewQueryParam = queryParams.webview === '1';
    var onMobileDevice = __TEST__ ? true : isMobileDevice();
    webview = (hasWebviewCookie || hasWebviewQueryParam) && onMobileDevice;
    var cookieValue = webview ? 1 : 0;
    document.cookie = COOKIE_NAME + '=' + cookieValue + ';path=/;';
  }
  return webview;
};

exports.expireIsWebviewCookie = expireIsWebviewCookie;
exports.isIOSDevice = isIOSDevice;
exports.isWebview = isWebview;
exports.isMobileDevice = isMobileDevice;
exports.COOKIE_NAME = COOKIE_NAME;
exports.default = isMobile;